import { useState } from 'react';
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps';
import './interactiveMarker.css';

const InteractiveMarker = ({
  position,
  children,
  markerId,
  borderColor = '#000',
  popupContent,
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleClick = () => setIsPopupOpen(!isPopupOpen);

  return (
    <AdvancedMarker
      position={position}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`interactive-marker ${className} ${isHovered ? 'hovered' : ''} ${isPopupOpen ? 'popup-open' : ''}`}
    >
      <div className="marker-inner">
        <div className="marker-default">
          {children}
        </div>
        <div className="marker-expanded popup-content">
          <button className="popup-close" onClick={(e) => { e.stopPropagation(); handleClick(); }}>
            ×
          </button>
          {popupContent}
        </div>
      </div>
    </AdvancedMarker>
  );
};

export default InteractiveMarker;